module.exports = __webpack_public_path__ + "img/pd-img-head5.0bad98ea.png";